import { faMeta } from "@fortawesome/free-brands-svg-icons";
import { faArrowCircleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./certifications.css";
import { motion } from "framer-motion";

export default function Certifications() {
  const certList = [
    {
      icon: "Meta",
      title: "Advanced React",
      description:
        "an online non-credit course authorized by Meta and offered through Coursera",
      link: "https://coursera.org/share/e553ad65ac32f1b48909d8ae419c17f2",
    },
    {
      icon: "",
      title: "Roadmap to React-Native Dev.",
      description:
        "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before the final copy is available.",
    },
  ];
  return (
    <div
      className="row"
      style={{
        overflowY: "scroll",
        overflowX: "hidden",
        gap: 10,
      }}
    >
      {certList.map((item, index) => (
        <motion.div
          key={index}
          className="card text-start certCard font-roobert mt-1"
          style={{
            cursor:
              item.link === null || typeof item.link === "undefined"
                ? ""
                : "pointer",
          }}
          initial={{
            opacity: 0,
            y: 20,
            backgroundColor: "#f2f2f2",
            color: "#000",
          }}
          viewport={{ once: true }}
          transition={{
            duration: 0.3,
            delay: index * 0.1,
          }}
          whileInView={{ opacity: 1, y: 0 }}
          whileHover={{
            scale: 0.96,
          }}
        >
          <a
            href={item.link}
            className="text-black"
            target="_blank"
            rel="noreferrer"
          >
            <div className="card-body">
              <div className="d-flex position-relative">
                <FontAwesomeIcon icon={faMeta} size="xl" />
                {!(item.link === null || typeof item.link === "undefined") && (
                  <FontAwesomeIcon
                    className="end-0 position-absolute"
                    icon={faArrowCircleRight}
                    size="xl"
                  />
                )}
              </div>
              <h4 className="card-title  pt-2">
                <b>{item.title}</b>
              </h4>
              <p className="card-text font-neue pt-2">{item.description}</p>
            </div>
          </a>
        </motion.div>
      ))}
    </div>
  );
}
